jQuery(function($){

	resizeWindow();
	  		
	$(window).resize(resizeWindow);
	
    // mobile menu
	$('.toggle_nav').on('click tap', function(e) {
		e.stopPropagation();
  		e.preventDefault();
		document.documentElement.setAttribute("data-modal-active",
		document.documentElement.getAttribute("data-modal-active") === "true" ? "false" : "true");
		if ($('#mobile_nav').hasClass('open')) {
			$('#mobile_nav_overlay').fadeOut(300, function() {
				$('#mobile_nav').removeClass('open');
			});
		} else {
			$('#mobile_nav_overlay').fadeIn(300, function() {
				$('#mobile_nav').addClass('open');
				$('html, body').animate({scrollTop: 0}, 'fast');
			});
		}
	});
	$('#mobile_nav .nav li.has_children a.primary').on('click tap', function(e) {
		e.stopPropagation();
  		e.preventDefault();
		$(this).parent().toggleClass('open');
      $(this).parent().toggleClass('openalt');
		$(this).next('ul').slideToggle('fast');
	});
  	$('#mobile_nav .nav li.has_grandchildren a.primary').on('click tap', function(e) {
		e.stopPropagation();
  		e.preventDefault();
		$(this).parent().toggleClass('open');
		$(this).next('ul').slideToggle('fast');
	});
	$('#mobile_nav_overlay').on('click tap', function(e) {
		e.stopPropagation();
  		e.preventDefault();
		document.documentElement.setAttribute("data-modal-active",
		document.documentElement.getAttribute("data-modal-active") === "true" ? "false" : "true");
		$(this).fadeOut(300, function() {
			$('#mobile_nav, #header .toggle_nav').removeClass('open');
		});
	});
  
    // mobile collection sidebar
    $('.toggle_sidebar').on('click tap', function() {
		if ($('#mobile_collection_sidebar').hasClass('open')) {
			$('#mobile_collection_sidebar').fadeOut(300, function() {
				$(this).removeClass('open');
				$('html,body').removeClass('locked');	
			});
		} else {
			$('#mobile_collection_sidebar').fadeIn(300, function() {
				$(this).addClass('open');
				$('html, body').animate({scrollTop: 0}, 'fast', function() {
					$('html,body').addClass('locked');	
				});
			});
		}
	});

	// section: home collection
	if ($('.section-home-collection').length) {
		$('.section-home-collection').each(function() {
			var $id = $(this).attr('id');
			var $slider = '#' + $id + ' .slider-wrap';
			var $lazy = '#' + $id + ' .product-thumb';
			var slider = tns({
				container: $slider,
				items: 1,
				lazyload: true,
				lazyLoadSelector: $lazy,
				controls: false,
				navPosition: 'bottom',
				navAsThumbnails: true,
				mouseDrag: true,
				edgePadding: 50,
				autoHeight: true,
				responsive: {
					768: {
						items: 2,
						edgePadding: 60,
						autoHeight: false
					},
					1024: {
						items: 3
					},
					1280: {
						items: 4
					}
				}
			});
		});
	}

	// section: home cards
	if ($('.section-home-cards').length) {
		$('.section-home-cards').each(function() {
			var $id = $(this).attr('id');
			var $cards = '#' + $id + ' .cards-wrap';
			var $lazy = '#' + $id + ' .card-img';
			var cards = tns({
				container: $cards,
				items: 1,
				lazyload: true,
				lazyLoadSelector: $lazy,
				controls: false,
				navPosition: 'bottom',
				navAsThumbnails: true,
				mouseDrag: true,
				edgePadding: 30,
				autoHeight: true,
				responsive: {
					768: {
						items: 2,
						edgePadding: 50,
						autoHeight: false
					},
					1024: {
						items: 3
					}
				}
			});
		});
	}

	// youtube background & youtube modal links
	if ($('.js-modal-btn').length) {
		$('.js-modal-btn').modalVideo();
	}
	if ($('[data-youtube]').length) {
		$('[data-youtube], [data-vbg]').youtube_background();
	}

    // search popup
    $('.toggle_search').on('click tap', function(e) { 
        e.preventDefault();
        e.stopPropagation();
        $('html, body').addClass('frozen');
        $('#popup-search').fadeIn(300);
    });
    $('#popup-search .close').on('click tap', function() {
        $('#popup-search').fadeOut(300, function() {
        	$('html, body').removeClass('frozen');
        });
    });  
        
    // product thumbs
    $('#product .images .thumbs .thumb').on('click tap', function() {
        var src = $(this).attr('rel');
        $('#product .images .thumbs .thumb').removeClass('active');
        $(this).addClass('active');
        $('#product .images .primary img').attr('src', src);
    });

	// product accordions
	$('#product .accordion .item .title').on('click tap', function() {
		$(this).parent().toggleClass('open');
		$(this).next().slideToggle('fast');
	});
    
    // all faqs accordions
	$('.faqs-accordion .item .title').on('click tap', function() {
		$(this).parent().toggleClass('open');
		$(this).next().slideToggle('fast');
	});
    
});

function resizeWindow() {

	var ww = $(window).width();
	/*var wh = $(window).height();*/

	// collection sidebar
	if ($('#collection .sidebar').length) {
		if (ww > 1024) {
			$('#collection .sidebar').stick_in_parent();
		} else {
			$('#collection .sidebar').trigger('sticky_kit:detach');
		}
	}

	// sticky mobile header pad
	var mhh = $('#shopify-section-global-header').outerHeight();
	$('#mobile_pad').css('height', mhh + 'px');
			
}

function cartRemove(variant_id) {
 
  var data = 'updates[' + variant_id + ']=0';
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json'
  })
  .done(function(data) {
    window.location.href = "/cart";
  });
  
}

function cartSubtract(variant_id, qty) {
 
  var newQty = qty - 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json'
  })
  .done(function() {
    window.location.href = "/cart";
  });
  
}

function cartAdd(variant_id, qty) {
 
  var newQty = qty + 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json'
  })
  .done(function() {
    window.location.href = "/cart";
  });
  
}